const { BASE_URL, NODE_ENV } = process.env;
const { VUE_APP_BRANDING, VUE_APP_FONT } = window.__env__ ? window.__env__ : {};
// If VUE_APP_BRANDING environmental variable is set, PLANT will show the logo in the branding folder, otherwise will show
// a default logo based on the NODE_ENV variable.
const BRANDING_PATH = `${BASE_URL}img/branding/${VUE_APP_BRANDING ? VUE_APP_BRANDING : "env-" + NODE_ENV
  }`;
const preferredFontName = VUE_APP_FONT || null;

const FONT_DEFINITIONS = {
	Gotham: {
		family: 'Gotham',
		src: '/img/branding/common/fonts/Gotham.otf',
		format: 'opentype'
	},
	ProximaNova: {
		family: 'ProximaNova',
		src: '/img/branding/entergy/fonts/ProximaNova.otf',
		format: 'opentype'
	}
};

const preferredFont = preferredFontName ? FONT_DEFINITIONS[preferredFontName] : null;

export default {
	logo_url: `${BRANDING_PATH}/navbar-logo.svg`,
	login_background_url: `${BRANDING_PATH}/login-background.jpg`,
	name: VUE_APP_BRANDING,
	font: preferredFont
};

function generateTenantCss() {
	if (!preferredFont) return '';

	return `
		@font-face {
			font-family: '${preferredFont.family}';
			src: url('${preferredFont.src}') format('${preferredFont.format}');
			font-display: swap;
		}`;
}

export function injectTenantFontFace() {
	const css = generateTenantCss();

	if (!css) return;

	const styleId = 'tenant-font-faces';

	const styleElement = document.createElement('style');
	styleElement.id = styleId;
	document.head.appendChild(styleElement);

	styleElement.textContent = css;
}
